document
  .querySelector("#Details-menu-drawer-container > summary")
  .addEventListener("click", function () {
    const details = document.querySelector(
      "#Details-menu-drawer-container > summary"
    );
    if (details.hasAttribute("open")) {
      details.removeAttribute("open");
    } else {
      details.setAttribute("open", "");
    }
  });
